import { useContext, useMemo } from 'react';

import LabelText from '@lcsc-ui/components/LabelText';
import { ProductItemContext } from '@lcsc-ui/providers/productItem';
import { ProductListContext } from '@lcsc-ui/providers/productList';
import useProductStore from '@lcsc-ui/store/product';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Utils from '@lcsc-ui/utils/Utils';

// 库存交期
export default function StockAndDeliver(props) {
  const { searchResult } = useContext(ProductListContext);
  const { index, rs_log } = useContext(ProductItemContext);

  const {
    productVO,
    hidePriceAndStock, // 隐藏价格和库存
    totalStockNumber, // 可订数量
    defaultAddressBelongWarehouse,
    jsWarehouseStockNumber, // 江苏仓库存
    gdWarehouseStockNumber, // 广东仓库存
    showProductSpuMapBtn,
    showProductSpuMap,
    onShowProductSpuMap,
    needBold,
  } = props;

  const { updateArrivalNoticeData } = useProductStore();

  // 订货提示
  const deliveryTimeDom = useMemo(() => {
    let str = '';
    if (productVO.selfProductCode) {
      str = `订货${productVO.deliveryTimeWayDays?.replace(/(\d+)/g, '<strong class="font-bold">$&</strong>')}`;
    } else if (productVO.productStockStatus === 'yes') {
      str = '现货最快4小时发货';
    } else if (productVO.productStockStatus === 'no') {
      str = '需订货';
    }
    if (!str) {
      return <></>;
    }
    return (
      <span
        className="mb-[6px] inline-block h-[18px] rounded-[3px] bg-[#EDEDED] px-[7px] leading-[18px] text-[#666]"
        dangerouslySetInnerHTML={{
          __html: str,
        }}
      ></span>
    );
  }, [productVO]);

  async function clickArrivalNotice() {
    buriedPoint({
      op: 'arrival_notice',
      data: {
        pc: productVO?.productId,
        kw: searchResult?.globalSearchKeyword,
        cp: searchResult?.currePage,
        brand: productVO?.productGradePlateName,
        model: productVO?.productModel,
        code: productVO?.productCode,
        ix: index,
        no: searchResult?.totalCount,
        rs_log,
      },
    });
    updateArrivalNoticeData({
      open: true,
      product: {
        productId: productVO?.productId,
        key: new Date().getTime(),
      },
    });
  }

  // 产品数量单位
  const productUnitDom = useMemo(() => {
    return (
      productVO?.productMinEncapsulationUnit && (
        <p className={`mb-[6px] text-[#333] ${needBold ? 'font-bold' : ''}`}>
          {productVO?.productMinEncapsulationNumber}
          {productVO?.productUnit}/{productVO.productMinEncapsulationUnit}
        </p>
      )
    );
  }, [productVO]);

  // 仓库
  const stockDom = useMemo(() => {
    if (hidePriceAndStock) {
      return <></>;
    }
    // c商品转p商品只显示单仓
    if (productVO.selfProductCode) {
      return (
        <>
          <LabelText label="库存" text={Utils.unitConversion(productVO?.stockNumber)}></LabelText>
          <LabelText label="增量" text={productVO?.convesionRatio}></LabelText>
          <LabelText
            label="最小包装"
            text={`${productVO?.productMinEncapsulationNumber}${productVO?.productUnit}`}
          ></LabelText>
        </>
      );
    } else if (productVO.productUnsealVendition !== 'no') {
      let stock = <></>;
      const notice = <></>;
      if (productVO.isPresent !== true) {
        if (defaultAddressBelongWarehouse === 'js') {
          stock = (
            <>
              {jsWarehouseStockNumber > 0 && (
                <LabelText label="江苏仓" text={Utils.unitConversion(jsWarehouseStockNumber)} textBold></LabelText>
              )}
              <LabelText label="广东仓" text={Utils.unitConversion(gdWarehouseStockNumber)} textBold></LabelText>
            </>
          );
        } else {
          stock = (
            <>
              <LabelText label="广东仓" text={Utils.unitConversion(gdWarehouseStockNumber)} textBold></LabelText>
              {jsWarehouseStockNumber > 0 && (
                <LabelText label="江苏仓" text={Utils.unitConversion(jsWarehouseStockNumber)} textBold></LabelText>
              )}
            </>
          );
        }
      }
      return (
        <>
          {stock}
          {productUnitDom}
          {notice}
        </>
      );
    }
  }, [
    productVO,
    hidePriceAndStock,
    totalStockNumber,
    gdWarehouseStockNumber,
    jsWarehouseStockNumber,
    defaultAddressBelongWarehouse,
  ]);

  const noticeBtn = useMemo(() => {
    if (productVO?.productUnsealVendition === 'yes' && productVO?.productStockStatus === 'no') {
      return (
        <button
          className="block text-[56657F] underline hover:text-[#0093E6] hover:no-underline"
          onClick={clickArrivalNotice}
        >
          到货通知
        </button>
      );
    }
  }, [productVO]);

  function clickShowProductSpuMap() {
    onShowProductSpuMap(!showProductSpuMap, 'packaging');
  }

  // 同系列商品
  const productSpuMapDom = useMemo(() => {
    if (!showProductSpuMapBtn) {
      return;
    }
    return (
      <button className="h-[26px]  rounded-[13px] text-[#1FA0E8]" onClick={clickShowProductSpuMap}>
        <span className="mr-[7px]">其它包装</span>
        {showProductSpuMap ? (
          <span className="mb-[-2px] ml-[px] inline-block size-[7px] rotate-[45deg] border-l-[1px] border-t-[1px] border-solid border-[#0294e8]"></span>
        ) : (
          <span className="mb-[3px] ml-[px] inline-block size-[7px] rotate-[225deg] border-l-[1px] border-t-[1px] border-solid border-[#0294e8]"></span>
        )}
      </button>
    );
  }, [showProductSpuMap, showProductSpuMapBtn]);

  return (
    <>
      {deliveryTimeDom}
      {stockDom}
      {noticeBtn}
      {productSpuMapDom}
    </>
  );
}

export function OldBatchStock(props) {
  const { productVO } = props;
  const { defaultAddressBelongWarehouse } = useContext(ProductListContext);

  return useMemo(() => {
    if (productVO?.isDeposit === false) {
      return (
        <>
          <LabelText label="库存" text={Utils.unitConversion(productVO?.oldBatchStockNumber)} textBold></LabelText>
          <LabelText label="最小起订量" text={productVO?.convesionRatio}></LabelText>
          <LabelText
            label="最小包装"
            text={`${productVO?.productMinEncapsulationNumber}${productVO?.productUnit}`}
          ></LabelText>
        </>
      );
    } else {
      if (defaultAddressBelongWarehouse === 'js') {
        return (
          <>
            {productVO?.jsWarehouseStockNumber > 0 && (
              <LabelText
                label="江苏仓"
                text={Utils.unitConversion(productVO?.jsWarehouseStockNumber)}
                labelClassName="text-[#333]"
                textBold
              ></LabelText>
            )}
            <LabelText
              label="广东仓"
              text={Utils.unitConversion(productVO?.gdWarehouseStockNumber)}
              labelClassName="text-[#333]"
              textBold
            ></LabelText>
          </>
        );
      } else {
        return (
          <>
            <LabelText
              label="广东仓"
              text={Utils.unitConversion(productVO?.gdWarehouseStockNumber)}
              labelClassName="text-[#333]"
              textBold
            ></LabelText>
            {productVO?.jsWarehouseStockNumber > 0 && (
              <LabelText
                label="江苏仓"
                text={Utils.unitConversion(productVO?.jsWarehouseStockNumber)}
                labelClassName="text-[#333]"
                textBold
              ></LabelText>
            )}
          </>
        );
      }
    }
  }, [productVO, defaultAddressBelongWarehouse]);
}
